import React from "react";
import { Modal, ModalBody, ModalFooter, Button } from "@windmill/react-ui";

const fieldsToCompare = [
  { label: "Mobile", key: "mobile_no" },
  { label: "Address", key: "address" },
  { label: "Pincode", key: "pincode" },
  { label: "state", key: "state_name" || "state" },
  { label: "city", key: "city_name" || "city" },
  { label: "Company Logo", key: "company_logo" },

  // { label: "changed_by", key: "changed_by" },
  //   { label: "Email", key: "email" },
  //   { label: "City", key: "city" },
  // Add more fields as needed
];



const AgentHistoryModal = ({ isOpen, onClose, data = [], originalData = {} }) => {
  const IMAGE_BASE_URL = process.env.REACT_APP_API_IMAGE_URL;
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalBody className="p-0">
        <div className="max-h-[75vh] overflow-y-auto px-6 py-4">
          <h2 className="text-lg font-medium mb-4 text-center">
            Agent Profile Change History
          </h2>

          {data.length === 0 ? (
            <p className="text-center text-gray-500">No history available.</p>
          ) : (
            <div className="space-y-6">
              {data.map((entry, index) => (
                <div
                  key={index}
                  className="border rounded-md shadow-sm p-4 bg-gray-50"
                >
                  <div className="mb-2 text-sm text-gray-600">
                    <strong>Changed By:</strong> {entry.changed_by || "System"} |{" "}
                    <strong>Status:</strong>{" "}
                    {entry.is_approved === 1
                      ? "Approved"
                      : entry.is_approved === 2
                        ? "Rejected"
                        : "Pending"}{" "}
                    | <strong>Date:</strong> {entry.created_at}
                  </div>

                  <table className="w-full text-sm table-auto">
                    <thead>
                      <tr className="bg-gray-200 text-gray-700">
                        <th className="p-2 text-left">Field</th>
                        <th className="p-2 text-left">Before</th>
                        <th className="p-2 text-left">Requested For</th>
                      </tr>
                    </thead>
                    <tbody>
                      {fieldsToCompare.map((field, i) => {
                        const before = originalData[field.key] || "-";
                        const after = entry[field.key] || "-";
                        const hasChanged = before !== after;
                        const isLogo = field.key === "company_logo";

                        return (
                          <tr className={`border-t`}>

                            <td className="p-2 font-medium text-gray-800">
                              {field.label}
                            </td>
                            <td className={`p-2 ${hasChanged ? "text-gray-400" : "text-gray-800"}`}>
                              {isLogo && before !== "-" ? (
                                <img
                                  src={`${IMAGE_BASE_URL}${before}`}
                                  alt="Previous Logo"
                                  className="h-12 object-contain border rounded"
                                />
                              ) : (
                                before
                              )}
                            </td>
                            <td
                              className={`p-2 ${hasChanged
                                ? "text-green-600 font-semibold"
                                : "text-gray-800"
                                }`}
                            >
                              {isLogo && after !== "-" ? (
                                <img
                                  src={`${IMAGE_BASE_URL}${after}`}
                                  alt="Requested Logo"
                                  className="h-12 object-contain border rounded"
                                />
                              ) : (
                                after
                              )}
                            </td>
                          </tr>


                        );
                      })}
                    </tbody>

                  </table>
                </div>
              ))}
            </div>
          )}
        </div>
      </ModalBody>


      <ModalFooter className="justify-center">
        <Button layout="outline" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default React.memo(AgentHistoryModal);
